import { ICAL_MAX_SIZE_MB, IMAGE_MAX_SIZE_MB } from "@/utils/validationUtils";
import { LocaleMessageDictionary, VueMessageType } from "vue-i18n";

export default {
  de: {
    common: {
      loading: 'lade...',
      true: 'Ja',
      false: 'Nein',
      privacyNotice: 'Durch Nutzung dieses Services stimmen Sie den Nutzungsbedingungen zu.',
      privacyNoticeButton: 'Akzeptieren',
      permissionerror: 'Sie verfügen nicht über die notwendigen Berechtigungen um TERES zu verwalten.',
      goToYourReservations: 'Ihre Reservierungen ({count})',
      goToYourReservationsSimple: 'Zu Ihren Reservierungen',
      maxReservations: 'Sie haben bereits die maximale Anzahl von {count} Reservierungen im Warenkorb erreicht.',
      duplicateReservation: 'Dieser Termin befindet sich bereits im Warenkorb.',
      reservationValidFor: 'noch {count} Minuten gültig',
      editYourReservations: 'Reservierungen bearbeiten',
      editYourPersonalData: 'Daten bearbeiten',
      overbookedTimeSlots: '1 überbuchter Termin | {count} überbuchte Termine',
      confirmAction: 'Wollen Sie die Aktion wirklich durchführen?',
      save: 'Speichern',
      cancel: 'Abbrechen',
      reset: 'Filter zurücksetzen',
      resetShort: 'Zurücksetzen',
      print: 'Drucken',
      printActual: 'Aktuelle Ansicht drucken',
      search: 'Suchen',
      delete: 'Löschen',
      panic: 'Alle Eingaben und Aktivitäten löschen',
      panicLong: 'Möchten Sie wirklich den Buchungsprozess abbrechen und Ihre eingegebenen Daten löschen? Dies betrifft nicht bereits gebuchte Zeiträume. Verwenden Sie hierfür bitte die Stornierungmöglichkeit, welche Sie per E-Mail bekommen haben.',
      monthPrev: 'Vorheriger Monat',
      monthNext: 'Nächster Monat',
      pagingPrev: 'Vorherige Seite',
      pagingNext: 'Nächste Seite',
      monthCurrent: 'Aktueller Monat',
      backToDashboard: 'Zurück zum Dashboard',
      backToOverview: 'Zurück zur Übersicht',
      backToTimeSlot: 'Zurück zum Termin',
      accessibilityRequired: 'Barrierefreier Zugang erforderlich',
      addReservations: 'Sitzplätze auswählen',
      addMoreReservations: 'Weitere Sitzplätze auswählen',
      faqLink: 'Hilfe zur Terminreservierung',
      faqLinkTitle: 'Hilfe zur Terminreservierung in einem neuen Fenster öffnen',
      from: 'von',
      occupied: 'belegt',
      ticketType: {
        NEW: 'Temporäre Reservierungen',
        BOOKED: 'Gültige Reservierungen',
        INVALID: 'Ungültige Reservierungen',
        CANCELLED: 'Stornierte Reservierungen'
      },
      ticketTypeSingle: {
        NEW: 'Temporäre Reservierung',
        BOOKED: 'Gültige Reservierung',
        INVALID: 'Ungültige Reservierung',
        CANCELLED: 'Stornierte Reservierung'
      },
      ticketEdit: 'Reservierung bearbeiten',
      timeSlotEdit: 'Termin bearbeiten',
      ticketCancel: 'Reservierung stornieren',
      ticketTime: 'Termin',
      holiday: {
        add: 'Feiertag hinzufügen',
        addIcal: 'Import von Feiertagen',
        edit: 'Feiertag bearbeiten',
        name: 'Name',
        description: 'Beschreibung',
        date: 'Tag'
      },
      room: {
        add: 'Raum hinzufügen',
        edit: 'Raum bearbeiten',
        editImage: 'Vorschaubild ändern',
        delete: 'Raum löschen',
        imageFile: 'Vorschaubild',
        imageAlt: 'Alternativtext (Barrierefreiheit)',
        name: 'Bezeichnung',
        description: 'Standortbeschreibung',
        capacity: 'Kapazität',
        reservationPeriod: 'Reservierungszeitraum',
        openStartValue: 'Reservierung möglich ab',
        openStartType: 'Einheit',
        openEndValue: 'Reservierung möglich bis',
        openEndType: 'Einheit',
        personCount: 'Personenzahl',
        additionalStartEndInfo: 'vor möglichem Reservierungstermin',
        notDeletable: 'Dieser Raum kann nicht gelöscht werden, da noch eine aktive Buchung vorhanden ist. | Dieser Raum kann nicht gelöscht werden, da noch {count} aktive Buchungen vorhanden sind.',
        sortRooms: 'Reihenfolge ändern',
        sortRoomsUp: 'nach oben verschieben',
        sortRoomsDown: 'nach unten verschieben',
        sortRoomsEnd: 'Sortierung beenden'
      },
      blacklist: {
        email: 'E-Mail',
        expiredAt: 'Gesperrt bis',
        description: 'Anmerkung',
        actions: 'Bearbeiten',
        delete: 'Blacklist-Eintrag entfernen',
        updated: 'Der Blacklist-Eintrag "{email}" wurde erfolgreich aktualisiert.',
        removed: 'Der Blacklist-Eintrag "{email}" wurde erfolgreich gelöscht.',
        added: 'Der Blacklist-Eintrag "{email}" wurde erfolgreich hinzugefügt.',
        item: 'Blacklist-Eintrag',
        add: 'Blacklist-Eintrag hinzufügen',
        edit: 'Blacklist-Eintrag bearbeiten',
        noEntry: 'Kein Blacklist-Eintrag für diesen Suchbegriff vorhanden.'
      },
      timeSlot: {
        add: 'Termin hinzufügen',
        edit: 'Termin bearbeiten',
        delete: 'Termin löschen',
        startTime: 'Uhrzeit von',
        endTime: 'Uhrzeit bis',
        startDate: 'Tag',
        repeatUntil: 'Wiederholen bis',
        daysOfWeek: 'Wochentage',
        includeHolidays: 'Feiertage einschließen',
        capacity: 'Kapazität',
        srCalendarOpenButton: 'Verfügbare Termine anzeigen',
        availableTime: 'Verfügbare Termine',
        bookTimeslot: 'Buchen',
        bookTimeslotFull: 'Ausgebucht',
        bookTimeslotTempFull: 'Nicht buchbar',
        bookTimeslotTempFullDesc: '"Nicht buchbar" kann bedeuten, dass ein anderer User diesen Termin gerade für 15 Minuten geblockt hat, kein Ticket mehr zur Verfügung steht, Sie zu dieser Zeit schon einen anderen Termin gebucht haben oder schon 5 Termine im Warenkorb haben.',
        isFull: 'Termin ausgebucht'
      },
      owner: {
        title: 'Titel',
        givenName: 'Vorname',
        surName: 'Nachname',
        organization: 'Organisation',
        email: 'E-Mail',
        phone: 'Telefon',
        accessible: 'Ich benötige einen barrierefreien Zugang zum Lesesaal',
        salutation: 'Anrede',
        salutations: {
          MR: 'Herr',
          MS: 'Frau',
          NONE: 'Keine Auswahl'
        }
      },
      dayTypes: {
        WORKING_DAY: 'Werktag',
        DAY: 'Tag'
      },
      days: {
        MONDAY: 'Montag',
        TUESDAY: 'Dienstag',
        WEDNESDAY: 'Mittwoch',
        THURSDAY: 'Donnerstag',
        FRIDAY: 'Freitag',
        SATURDAY: 'Samstag',
        SUNDAY: 'Sonntag',
        MON_SHORT: 'Mo',
        TUE_SHORT: 'Di',
        WED_SHORT: 'Mi',
        THU_SHORT: 'Do',
        FRI_SHORT: 'Fr',
        SAT_SHORT: 'Sa',
        SUN_SHORT: 'So'
      },
      form: {
        required: 'Pflichtfeld'
      },
      error: {
        ticket__validation_error: 'Bei der Ticketbuchung ist ein Fehler aufgetreten, bitte versuchen Sie es noch einmal.',
        validation__error: 'Eine ihrer Daten (z.B.: E-Mail Adresse oder Telefonnummer) sind falsch eingegeben, bitte überprüfen Sie diese und probieren Sie es noch einmal.',
        max_tickets_per_time_reached: 'Der Termin überschneidet sich mit einem Termin in ihrem Warenkorb.',
        max_tickets_per_day_reached :'Maximale Anzahl von Tickets an einem Tag erreicht.',
        timeslot_no_tickets_left: 'Der Termin ist ausgebucht.',
        max_tickets_by_user_reached: 'Sie haben Ihre maximale Ticketanzahl erreicht.',
        timeslot_not_open: 'Dieser Termin kann online nicht mehr gebucht werden. Kurzfristige Termine können ausschließlich telefonisch reserviert werden.',
        timeslot__overlapping: 'Es gibt bereits einen Timeslot innerhalb dieser Uhrzeiten.',
        unknown: 'Leider ist ein unbekannter Fehler aufgetreten. Bitte probieren Sie es später noch einmal.',
        http__access_denied_exception: 'Leider ist ein Fehler aufgetreten. Bitte probieren Sie es später noch einmal.',
        booking__email_blacklisted: 'Dieser Benutzer ist gesperrt. Bitte kontaktieren Sie den Support.',
        ticket__validation_error_timeslot_not_open: 'Dieser Termin kann online nicht mehr gebucht werden. Kurzfristige Termine können ausschließlich telefonisch reserviert werden.',
        ticket__validation_error_max_tickets_per_time_reached: 'Der Termin überschneidet sich mit einem Termin in ihrem Warenkorb',
        ticket__validation_error_max_tickets_per_day_reached :'Maximale Anzahl von Tickets an einem Tag erreicht.',
        ticket__validation_error_timeslot_no_tickets_left: 'Der Termin ist ausgebucht.',
        ticket__validation_error_max_tickets_by_user_reached: 'Sie haben Ihre maximale Ticketanzahl erreicht.',
        recaptcha__validation_error: 'Ihr Reservierungsversuch wurde als potenziell automatisierter Vorgang identifiziert und daher abgelehnt. Bitte versuchen Sie es erneut und wenden Sie sich bei anhaltenden Problem an +43-(0)1-79 540-0.',
        blacklist__email_already_exists: 'Diese E-Mail existiert bereits.'
      }
    },
    validators: {
      required: 'Bitte geben Sie in Feld „{0}“ einen Wert ein.',
      requiredInteger: 'Bitte geben Sie in Feld „{0}“ eine Ganzzahl ein.',
      requiredTime: 'Bitte wählen Sie eine gültige Uhrzeit aus.',
      isAfterStartTime: 'Die gewählte „Uhrzeit bis“ muss NACH der gewählten „Uhrzeit von“ liegen.',
      isAfterStartDate: 'Datum nicht gültig oder endet VOR Startdatum.',
      requiredFutureDate: 'Das Datum muss in der Zukunft liegen',
      isDateString: 'Bitte wählen Sie ein gültiges Datum aus.',
      requiredWeekDay: 'Bitte wählen Sie mindestens einen Wochentag aus.',
      email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
      minLength: 'Bitte geben Sie in Feld „{0}“ mindestens {1} Zeichen ein.',
      maxLength: 'Bitte geben Sie in Feld „{0}“ maximal {1} Zeichen ein.',
      between: 'Bitte geben Sie in Feld „{0}“ einen Wert zwischen {1} und {2} ein.',
      imageMaxSize: `Bitte wählen Sie ein Bild mit maximal ${IMAGE_MAX_SIZE_MB} MB aus.`,
      imageJpegOrPng: 'Bitte wählen Sie eine JPEG oder PNG Datei aus.',
      imageRequired: 'Bitte wählen Sie ein gültiges Bild aus.',
      icalRequired: 'Bitte wählen Sie eine gültige Kalender-Datei ical, ics Bild aus.',
      icalMaxSize: `Bitte wählen Sie ein Kalender-Datei ical, ics mit maximal ${ICAL_MAX_SIZE_MB} MB aus.`,
      isTelephoneString: 'Bitte geben Sie eine Telefonnummer ein, welche nur Zahlen oder das Sonderzeichen \'+\' enthält. z.B. +43123456789',
      privacyNoticeRequired: 'Bitte akzeptieren Sie die Einverständniserklärung um fortzufahren. ',
      fallback: 'Bitte geben Sie in Feld „{0}“ einen gültigen Wert ein.',
    },
    comps: {
      reservationStateHeading: {
        loading: 'Reservierung wird durchgeführt...',
        success: 'Ihre Terminreservierung wurde durchgeführt',
        error: 'Die Reservierung konnte nicht durchgeführt werden!'
      },
    },
    views: {
      overbooked: {
        title: 'Überbuchte Termine',
        noTimeSlots: 'Derzeit gibt es keine überbuchten Termine',
        timeSlot: 'Datum & Uhrzeit',
        room: 'Raum',
        ticketCount: 'Reservierungen',
        capacity: 'Kapazität',
        actions: 'Bearbeiten',
      },
      roomChooser: {
        title: 'Terminreservierung',
        resetted: 'Ihre Eingaben wurden zurückgesetzt.'
      },
      room: {
        title: 'Termin auswählen',
        chooseAnotherRoom: 'Anderen Saal wählen',
        infoTextCount: 'Sie können noch {count} von {max} Terminen wählen.',
        infoTextUnblock: 'Wenn Sie die Reservierung innerhalb von {count} Minuten nicht abschließen, wird Ihr Sitzplatz wieder freigegeben.',
      },
      yourReservations: {
        title: 'Ihre Reservierungen',
        infoText: 'Termine im Warenkorb bleiben noch {count} Minuten für Sie reserviert. Wenn Sie die Reservierung innerhalb von {count} Minuten nicht abschließen, wird Ihr Sitzplatz wieder freigegeben.',
        proceedToYourData: 'Weiter zu Ihren Daten',
        noReservations: 'Ihr Warenkorb ist leer.'
      },
      yourPersonalData: {
        title: 'Ihre Daten',
        requiredFieldsText: 'Die mit * (Stern, Asterisk) gekennzeichneten Eingabefelder sind Pflichtfelder und müssen ausgefüllt sein.',
        infoText: 'Ihre personenbezogenen Anmeldedaten werden von unseren Mitarbeiterinnen und Mitarbeitern verantwortungsvoll behandelt und nur im Sinne und zum Zweck der Terminreservierung Ihres Forschungsaufenthaltes genutzt und am darauffolgenden Tag des gebuchten Forschungsaufenthaltes-Tages gelöscht. Weitergehende Datenschutzinformationen unter ',
        infoTextLink: 'https://www.oesta.gv.at/siteinfo/datenschutz.html',
        infoTextLinkTitle: 'Datenschutz Seite in neuem Fenster öffnen',
        securityText: 'Bei jedweder missbräuchlicher Anwendung des Anmeldetools (zB Anmeldung einer Person unter falschen bzw. verschiedenen Identitäten) behält sich das ÖSTA einen Sperrvermerk im Anmeldetool vor.',
        proceedToSummary: 'Weiter zur Zusammenfassung'
      },
      summary: {
        title: 'Zusammenfassung',
        titleBooked: 'Buchungsbestätigung',
        titleYourReservations: 'Ihre Reservierungen',
        titleYourData: 'Ihre Daten',
        infoText: 'Sie erhalten eine Buchungsbestätigung an { email }. ',
        doOrder: 'Termin reservieren | Termine reservieren',
        success: 'Ihre Terminreservierung wurde durchgeführt',
        noTickets: 'In ihrem Warenkorb befinden sich keine gültigen Reservierungen.',
        errorMessageGeneral: 'Leider ist bei der Reservierung etwas schief gelaufen. Bitte probieren Sie es später nochmals.'
      },
      reservationConfirmation: {
        title: 'Buchungsbestätigung',
        infoText: 'Sie erhalten eine Buchungsbestätigung an { email }. ',
        errorMessage: 'Ein unerwarteter Fehler ist aufgetreten, bitte versuchen Sie es später noch einmal.',
        noTickets: 'Dieser Reservierung sind keine Termine mehr zugeordnet.',
        invalidOwnerId: 'Es konnte keine gültige Reservierung für die ID \'{msg}\' gefunden werden.',
        newReservation: 'Neue Reservierung durchführen',
        cancel: 'Reservierung stornieren',
        success: 'Stornierung erfolgreich'
      },
      dashboard: {
        title: 'Teres Verwaltung',
        editLabels: 'Texte bearbeiten',
        editRoomsAndReservations: 'Räume und Termine verwalten',
        reservationsList: 'Reservierungsliste',
        holidayList: 'Feiertagskalender',
        blacklist: 'Blacklist',
        reports: 'Reports',
        overbooked: 'Überbuchte Termine'
      },
      roomList: {
        title: 'Räume und Termine verwalten',
        configureTimeSlots: 'Termine konfigurieren'
      },
      roomAdd: {
        title: 'Raum hinzufügen'
      },
      roomEdit: {
        title: 'Raum bearbeiten',
        save: 'Änderungen speichern',
        confirmDelete: "Wollen Sie den Raum '{0}' wirklich löschen?",
        infopopup: {
          edit: 'Änderungen gespeichert',
          delete: 'Raum gelöscht'
        }
      },
      roomEditImage: {
        title: 'Vorschaubild bearbeiten',
        save: 'Bild hochladen',
        infoText: 'Hier können Sie ein individuelles Vorschaubild hochladen. Dieses sollte für das Web optimiert und im Format JPEG oder PNG sein. ',
        delete: 'Bild löschen',
        infopopup: {
          edit: 'Änderungen gespeichert',
          delete: 'Bild gelöscht'
        }
      },
      timeSlotList: {
        title: 'Termine konfigurieren {roomName}',
        multiEditCapacity: 'Kapazität mehrerer Termine bearbeiten'
      },
      timeSlotAdd: {
        title: 'Termin hinzufügen',
        confirmation: {
          title: 'Termin angelegt | {count} Termine angelegt'
        }
      },
      timeSlotEdit: {
        title: 'Termin bearbeiten',
        save: 'Änderungen speichern',
        confirmDelete: "Wollen Sie den Termin im Raum „{0}“ am {1} von {2} bis {3} wirklich löschen?",
        room: 'Raum',
        date: 'Datum',
        notDeletable: 'Dieser Termin kann nicht gelöscht werden, da noch eine aktive Buchung vorhanden ist. | Dieser Termin kann nicht gelöscht werden, da noch {count} aktive Buchungen vorhanden sind.',
        errorGeneral: 'Leider ist beim Bearbeiten / Löschen ein Fehler aufgetreten. Bitte probieren Sie es später nochmals oder wenden Sie sich an den Support.',
        confirmation: {
          change: 'Termin geändert',
          delete: 'Termin gelöscht'
        },
        addReservation: 'Reservierung hinzufügen',
        reservations: 'Reservierungen an diesem Termin'
      },
      timeSlotEditMultiCapacity: {
        title: 'Kapazität von mehreren Terminen anpassen',
        from: 'Von',
        until: 'Bis',
        save: 'Kapazität aller Termine in diesem Zeitraum anpassen',
        confirmation: 'Die Kapazität aller Termine zwischen {from} und {until} in Raum {roomName} wurde auf {capacity} gesetzt!'
      },
      timeSlotBook: {
        title: 'Reservierung hinzufügen',
        room: 'Raum',
        dateTime: 'Termin',
        book: 'Reservierung für Benutzer durchführen',
        success: 'Reservierung für "{givenName} {surName}" erfolgreich durchgeführt',
      },
      reservations: {
        title: 'Reservierungen',
        search: 'Suchbegriff',
        searchFrom: 'Von',
        searchUntil: 'Bis',
        sortColumns: {
          room: 'Raum',
          name: 'Nachname, Vorname',
          institution: 'Institution',
          email: 'E-Mail',
          date: 'Datum'
        },
        action: 'Bearbeiten'
      },
      reservationEdit: {
        title: 'Reservierung bearbeiten',
        status: 'Status',
        confirmDelete: "Wollen Sie wirklich die Reservierung von {msg} stornieren?|Wollen Sie wirklich die Reservierung von {msg} stornieren? Sie können auch folgende weitere Reservierungen aus demselben Bestellprozess stornieren:",
        cancelTicket: 'Reservierung stornieren',
        ticketsCancelled: '1 Reservierung wurde erfolgreich storniert.|{count} Reservierungen wurden erfolgreich storniert.',
      },
      blacklist: {
        title: 'Blacklist'
      },
      blacklistAdd: {
        title: 'Blacklist-Eintrag hinzufügen'
      },
      blacklistEdit: {
        title: 'Blacklist-Eintrag bearbeiten'
      },
      holidayList: {
        title: 'Feiertagskalender',
        decrementYear: 'vorheriges Jahr',
        incrementYear: 'nächstes Jahr',
        noHolidays: 'Für das Jahr {msg} sind keine Feiertage konfiguriert.',
        infopopup: {
          delete: 'Feiertag gelöscht'
        }
      },
      holidayAdd: {
        title: 'Feiertag hinzufügen',
        infopopup: {
          success: 'Feiertag hinzugefügt'
        }
      },
      holidayImport: {
        title: 'Feiertag-Import',
        save: 'Feiertag(e) importieren',
        file: 'Kalender-Datei ical, ics',
        infopopup: {
          success: 'Feiertag(e) importiert'
        }
      },
      holidayEdit: {
        title: 'Feiertag bearbeiten',
        save: 'Änderungen speichern',
        infopopup: {
          success: 'Feiertag bearbeitet'
        }
      },
      reports: {
        title: 'Reports',
        noReports: 'Es sind derzeit keine Reports verfügbar.',
        occupancy: 'Auslastungs- und Stornierungsauswertung',
        daily: 'Tagesreport für Raum {msg}'
      },
      dailyReport: {
        title: 'Täglicher Report',
        timeSlot: 'Uhrzeit',
        seatNumber: 'Sitzplatz',
        date: 'Datum',
        accessibilityRequired: 'Barrierefreier Zugang?',
        noEntry: 'Es gibt an diesem Tag keine Reservierungen.'
      },
      occupancyReport: {
        title: 'Auslastungs- und Stornierungsauswertung',
        dateFrom: 'Von',
        dateUntil: 'Bis',
        timeSlot: 'Termin',
        timeSlotType: 'Art der Auswertung',
        room: 'Raum',
        capacity: 'Kapazität',
        noEntry: 'Es gibt keine auszuwertenden Termine innerhalb der gewählten Filterkriterien.',
        timeSlotTypes: {
          BOOKED: 'Auslastung',
          CANCELLED: 'Stornierungen'
        },
        absolute: {
          BOOKED: 'Auslastung absolut',
          CANCELLED: 'Stornierungen absolut'
        },
        percentage: {
          BOOKED: 'Auslastung relativ zur Kapazität',
          CANCELLED: 'Stornierungen relativ zur Kapazität'
        }
      },
      wizard: {
        reservation: 'Termin reservieren',
        dataUser: 'Ihre Daten',
        finalize: 'Abschließen',
        confirmation: 'Bestätigung?'
      }
    }
  },
  en: {
    common: {
      loading: 'loading...',
      true: 'yes',
      false: 'no',
      privacyNotice: 'By using this service you agree to the terms of use for this service.',
      privacyNoticeButton: 'Accept',
      permissionerror: 'You are missing the necessary permissinos for managing TERES.',
      goToYourReservations: 'Your reservations ({count})',
      goToYourReservationsSimple: 'Go to your reservations',
      maxReservations: 'You have reached the maximum amount of {count} reservations in the shopping cart.',
      duplicateReservation: 'This appointment is already in the shopping cart.',
      reservationValidFor: 'valid for {count} more minutes',
      editYourReservations: 'Edit reservations',
      editYourPersonalData: 'Edit data',
      overbookedTimeSlots: '1 invalid time slot|{count} invalid time slots',
      confirmAction: 'Do you really want to continue with this action?',
      save: 'Save',
      cancel: 'Cancel',
      reset: 'reset filters',
      resetShort: 'reset',
      print: 'print',
      printActual: 'print actual view',
      search: 'search',
      delete: 'Delete',
      panic: 'Delete all inputs',
      panicLong: 'Do you really want to cancel the booking process and delete your entered data? This does not apply to periods that have already been booked. Please use the cancellation option that you received by email.',
      monthPrev: 'Previous month',
      monthNext: 'Next month',
      pagingPrev: 'Previous page',
      pagingNext: 'Next page',
      monthCurrent: 'Current month',
      backToDashboard: 'Back to dashboard',
      backToOverview: 'Back to overview',
      backToTimeSlot: 'back to timeslot',
      accessibilityRequired: 'Accessible access required',
      addReservations: 'add reservations',
      addMoreReservations: 'add more reservations',
      faqLink: 'Frequently asked questions',
      faqLinkTitle: 'Open frequently asked questions in new tab',
      from: 'of',
      occupied: 'occupied',
      ticketType: {
        NEW: 'Temporary reservations',
        BOOKED: 'Valid reservations',
        INVALID: 'Invalid reservations',
        CANCELLED: 'Cancelled reservations'
      },
      ticketTypeSingle: {
        NEW: 'Temporary reservation',
        BOOKED: 'Valid reservation',
        INVALID: 'Invalid reservation',
        CANCELLED: 'Cancelled reservation'
      },
      ticketEdit: 'edit reservation',
      timeSlotEdit: 'edit time slot',
      ticketCancel: 'cancel reservation',
      ticketTime: 'date & time',
      holiday: {
        add: 'add holiday',
        addIcal: 'import holidays from file',
        edit: 'edit holiday',
        name: 'name',
        description: 'description',
        date: 'date'
      },
      room: {
        add: 'Add room',
        edit: 'Edit room',
        editImage: 'Change preview image',
        delete: 'Delete room',
        imageFile: 'Preview image',
        imageAlt: 'Alternative text (accessibility)',
        name: 'Name',
        description: 'Location description',
        capacity: 'Capacity',
        reservationPeriod: 'Reservation period',
        openStartValue: 'Reservation possible from',
        openStartType: 'Unit',
        openEndValue: 'Reservation possible until',
        openEndType: 'Unit',
        personCount: 'Number of people',
        additionalStartEndInfo: 'before possible reservation date',
        notDeletable: 'This room cannot be deleted, as there is still 1 active reservations present. | This room cannot be deleted as long as there are still {count} active reservations present.',
        sortRooms: 'Change order',
        sortRoomsUp: 'Move up',
        sortRoomsDown: 'Move down',
        sortRoomsEnd: 'Close view'
      },
      blacklist: {
        email: 'email',
        expiredAt: 'blocked until',
        description: 'note',
        actions: 'edit',
        delete: 'Remove Blacklist entry',
        updated: 'Blacklist entry "{email}" was successfully updated.',
        removed: 'Blacklist entry "{email}" was successfully removed.',
        added: 'Blacklist entry "{email}" was successfully added.',
        item: 'Blacklist entry',
        add: 'Add Blacklist entry',
        edit: 'Edit Blacklist entry',
        noEntry: 'No Blacklist entry for this search term.'
      },
      timeSlot: {
        add: 'Add appointment',
        edit: 'Edit appointment',
        delete: 'Delete appointment',
        startTime: 'Time from',
        endTime: 'Time until',
        startDate: 'Day',
        repeatUntil: 'Repat until',
        daysOfWeek: 'Days of the Week',
        includeHolidays: 'Include holidays',
        capacity: 'Capacity',
        srCalendarOpenButton: 'Show available timeslots',
        availableTime: 'Available timeslots',
        bookTimeslot: 'Book',
        bookTimeslotFull: 'Full',
        bookTimeslotTempFull: 'Not bookable',
        bookTimeslotTempFullDesc: '"Not bookable" can mean that another user has just blocked this appointment for 15 minutes, that there is no longer a ticket available, that you have already booked another appointment at this time or that you already have 5 appointments in your shopping cart.',
        isFull: 'No available timeslots left'
      },
      owner: {
        title: 'Title',
        givenName: 'Given name',
        surName: 'Surname',
        organization: 'Organization',
        email: 'Email',
        phone: 'Telephone',
        accessible: 'I require accessible access to the reading room.',
        salutation: 'Salutation',
        salutations: {
          MR: 'Mister',
          MS: 'Ms',
          NONE: 'No selection'
        }
      },
      dayTypes: {
        WORKING_DAY: 'Weekday',
        DAY: 'Day'
      },
      days: {
        MONDAY: 'Monday',
        TUESDAY: 'Tuesday',
        WEDNESDAY: 'Wednesday',
        THURSDAY: 'Thursday',
        FRIDAY: 'Friday',
        SATURDAY: 'Saturday',
        SUNDAY: 'Sunday',
        MON_SHORT: 'Mo',
        TUE_SHORT: 'Tu',
        WED_SHORT: 'We',
        THU_SHORT: 'Th',
        FRI_SHORT: 'Fr',
        SAT_SHORT: 'Sa',
        SUN_SHORT: 'Su'
      },
      form: {
        required: 'Pflichtfeld'
      },
      error: {
        ticket__validation_error: 'Tere is an error in the booking, please try it again.',
        validation__error: 'There is an error in your userinformation, please check if you entered the fields right.',
        max_tickets_per_time_reached: 'The appointment overlaps with an appointment in your shopping cart.',
        max_tickets_per_day_reached :'Maximum tickets for this day reached.',
        timeslot_no_tickets_left: 'The appointment is fully booked.',
        max_tickets_by_user_reached: 'You reached your maximum ammount of tickets.',
        timeslot_not_open: 'This appointment can no longer be booked online. Short-term appointments can only be reserved by telephone.',
        timeslot__overlapping: 'There already exists a timeslot within the given timeframe.',
        unknown: 'An unknown error occured, please try again later.',
        http__access_denied_exception: 'An error occurred, please try again later.',
        booking__email_blacklisted: 'This user is blocked, please contact the support team.',
        ticket__validation_error_timeslot_not_open: 'This appointment can no longer be booked online. Short-term appointments can only be reserved by telephone.',
        ticket__validation_error_max_tickets_per_time_reached: 'The appointment overlaps with an appointment in your shopping cart.',
        ticket__validation_error_max_tickets_per_day_reached :'Maximum tickets for this day reached.',
        ticket__validation_error_timeslot_no_tickets_left: 'The appointment is fully booked.',
        ticket__validation_error_max_tickets_by_user_reached: 'You reached your maximum ammount of tickets.',
        recaptcha__validation_error: 'Your reservation attempt was identified as a potentially automated process and was therefore rejected. Please try again and contact +43-(0)1-79 540-0 if the problem persists.',
        blacklist__email_already_exists: 'This e-mail already exists.'
      },
    },
    validators: {
      required: 'Please enter a value into field “{0}”.',
      requiredInteger: 'Please enter an integer value into field “{0}”.',
      requiredTime: 'Please select a valid time.',
      isAfterStartTime: 'The selected “Time Until” must be after the selected “Time from”.',
      isAfterStartDate: 'Date not valid or ends BEFORE start date.',
      requiredFutureDate: 'Date must be in the future.',
      isDateString: 'Please select a valid date.',
      requiredWeekDay: 'Please select at least one weekday.',
      email: 'Please enter a valid email address.',
      minLength: 'Please enter at least {1} characters into field “{0}”.',
      maxLength: 'Please enter no more than {1} characters into field “{0}”.',
      between: 'Please enter into field “{0}” a value between {1} and {2}.',
      imageMaxSize: `Please select an image with a maximum of ${IMAGE_MAX_SIZE_MB} MB.`,
      imageJpegOrPng: 'Please select a JPEG or PNG file.',
      imageRequired: 'Please select a valid image.',
      icalRequired: 'Please select a valid calendar file ical, ics.',
      icalMaxSize: `Please select a calendar file ical, ics with a maximum of ${ICAL_MAX_SIZE_MB} MB.`,
      isTelephoneString: 'Please enter a valid telephone number containing only numbers or the character \'+\'. e.g. +43123456789',
      privacyNoticeRequired: 'Please accept the declaration of consent in order to proceed. ',
      fallback: 'Please enter a valid value into field “{0}”.',
    },
    comps: {
      reservationStateHeading: {
        loading: 'Your reservation is being processed...',
        success: 'Your reservation has been successful',
        error: 'Your reservation could not be completed!',
      },
    },
    views: {
      overbooked: {
        title: 'Overbooked timeslots',
        noTimeSlots: 'Currently there are no overbooked timeslots. ',
        timeSlot: 'date & time',
        room: 'room',
        ticketCount: 'reservations',
        capacity: 'capacity',
        actions: 'edit',
      },
      roomChooser: {
        title: 'Book a reading room',
        resetted: 'All your input has been resetted.'
      },
      room: {
        title: 'Choose appointment',
        chooseAnotherRoom: 'choose another room',
        infoTextCount: 'You can still choose {count} out of {max} reservations.',
        infoTextUnblock: 'Your shopping cart is reserved for {count} more minutes. Afterwards your shopping cart will be cleared.',
      },
      yourReservations: {
        title: 'Your reservations',
        infoText: 'Selections remain in your shopping cart for {count} minutes. Afterwards your shopping cart will be cleared.',
        proceedToYourData: 'Proceed to your personal data',
        noReservations: 'No reservations found.'
      },
      yourPersonalData: {
        title: 'Your data',
        requiredFieldsText: 'All fields marked with * (asterix) are mandatory and need to be filled out.',
        infoText: 'My personal data is treated with due care by the employees of the Austrian State Archives, only used for the purpose of handling your reservation and will be deleted the day after your reservation. More Information here:',
        infoTextLink: 'https://www.oesta.gv.at/siteinfo/datenschutz.html',
        infoTextLinkTitle: 'Open privacy information in new window',
        securityText: 'In the event of any improper use of the registration tool (e.g. registration of a person under false or different identities), the ÖSTA reserves the right to block the registration tool.',
        proceedToSummary: 'Continue to summary',
      },
      summary: {
        title: 'Summary',
        titleBooked: 'Reservation confirmation',
        titleYourReservations: 'Your reservations',
        titleYourData: 'Your data',
        infoText: 'You will receive a confirmation of reservation at { email }. ',
        doOrder: 'Reserve appointment | Reserve appointments',
        success: 'Your reservation has been completed',
        noTickets: 'No valid reservations could be found in your shopping cart.',
        errorMessageGeneral: 'Unfortunately something went wrong with the reservation. Please try again later.'
      },
      reservationConfirmation: {
        title: 'Reservation confirmation',
        infoText: 'You will receive a confirmation email at { email }. ',
        errorMessage: 'An unknown error occured. Please try again later.',
        noTickets: 'There are no more appointments in this reservations.',
        invalidOwnerId: 'No valid reservation could be found for id \'{msg}\'.',
        newReservation: 'Start new reservation',
        cancel: 'cancel reservation',
        success: 'cancellation of reservation successful',
      },
      dashboard: {
        title: 'Teres administration',
        editLabels: 'edit texts',
        editRoomsAndReservations: 'Manage rooms and reservations',
        reservationsList: 'reservations list',
        holidayList: 'holiday calendar',
        blacklist: 'blacklist',
        reports: 'reports',
        overbooked: 'Overbooked'
      },
      roomList: {
        title: 'Administer rooms and appointments',
        configureTimeSlots: 'Configure appointments'
      },
      roomAdd: {
        title: 'Add room'
      },
      roomEdit: {
        title: 'Edit room information',
        save: 'Save changes',
        confirmDelete: "Do you really want to delete room '{0}'?",
        infopopup: {
          edit: 'Changes saved',
          delete: 'Room deleted'
        }
      },
      roomEditImage: {
        title: 'Edit preview image',
        save: 'Upload image',
        infoText: 'Here you can upload web-optimized images in the formats JPEG or PNG. ',
        delete: 'Delete image',
        infopopup: {
          edit: 'Changes saved',
          delete: 'Image deleted'
        }
      },
      timeSlotList: {
        title: 'Configure appointments {roomName}',
        multiEditCapacity: 'Change the capacity of multiple time slots'
      },
      timeSlotAdd: {
        title: 'Add time slot',
        confirmation: {
          title: 'time slot added | {count} time slots added'
        }
      },
      timeSlotEdit: {
        title: 'Edit time slot',
        save: 'Save changes',
        confirmDelete: "Do you really want to delete the appointment in room “{0}” on {1} from {2} to {3}?",
        notDeletable: 'This timeslot cannot be deleted, as there is still 1 active reservations present. | This timeslot cannot be deleted as long as there are still {count} active reservations present.',
        errorGeneral: 'Unfortunately an error occurred while editing / deleting. Please try again later or contact support.',
        confirmation: {
          change: 'Timeslot changed',
          delete: 'Timeslot deleted'
        },
        addReservation: 'add reservation for user',
        reservations: 'reservations at this time slot'
      },
      timeSlotEditMultiCapacity: {
        title: 'Adapt capaity of time slots',
        from: 'from',
        until: 'until',
        save: 'change the capacity of affected time slots',
        confirmation: 'the capacity of all time slots between {from} and {until} in room {roomName} was set to {capacity}!'
      },
      timeSlotBook: {
        title: 'Book time slot',
        room: 'room',
        dateTime: 'time slot',
        book: 'add reservation for user',
        success: 'reservation for user "{givenName} {surName}" succesfull',
      },
      reservations: {
        title: 'Reservations',
        search: 'Search Term',
        searchFrom: 'from',
        searchUntil: 'until',
        sortColumns: {
          room: 'room',
          name: 'surname, given name',
          institution: 'institution',
          email: 'email',
          date: 'date'
        },
        action: 'edit'
      },
      reservationEdit: {
        title: 'edit reservation',
        status: 'state',
        confirmDelete: "Do you really want to delete the reservation of {msg}?|Do you really want to delete the reservation of {msg}? You can also delete further reservations of this process:",
        cancelTicket: 'cancel reservation',
        ticketsCancelled: 'reservation cancelled|{count} reservations cancelled',
      },
      blacklist: {
        title: 'Blacklist'
      },
      blacklistAdd: {
        title: 'Add Blacklist entry'
      },
      blacklistEdit: {
        title: 'Edit Blacklist entry'
      },
      holidayList: {
        title: 'holiday calendar',
        decrementYear: 'previous year',
        incrementYear: 'next year',
        noHolidays: 'For the year {msg} no holidays are configured.',
        infopopup: {
          delete: 'holiday deleted'
        }
      },
      holidayAdd: {
        title: 'add holiday',
        infopopup: {
          success: 'holiday added'
        }
      },
      holidayImport: {
        title: 'holiday import',
        save: 'import holiday(s)',
        file: 'calendar file \\(ical, ics\\)',
        infopopup: {
          success: 'holiday(s) imported'
        }
      },
      holidayEdit: {
        title: 'edit holiday',
        save: 'Save changes',
        infopopup: {
          success: 'changes saved'
        }
      },
      reports: {
        title: 'Reports',
        occupancy: 'Occupation and Cancellation report',
        noReports: 'Currently there are no reports available.',
        daily: 'Daily report for room {msg}'
      },
      dailyReport: {
        title: 'Daily report Report',
        timeSlot: 'Timeslot',
        seatNumber: 'Seat number',
        date: 'Datum',
        accessibilityRequired: 'Accessibility?',
        noEntry: 'There are no reservations for the given date.'
      },
      occupancyReport: {
        title: 'Occupation and Cancellation report',
        dateFrom: 'From',
        dateUntil: 'Until',
        timeSlot: 'Time slot',
        timeSlotType: 'Report type',
        room: 'Room',
        capacity: 'Capacity',
        noEntry: 'There are no time slots that match the selected criteria.',
        timeSlotTypes: {
          BOOKED: 'Occupancy',
          CANCELLED: 'Cancellation'
        },
        absolute: {
          BOOKED: 'Occupancy absolute',
          CANCELLED: 'Cancellation absolute'
        },
        percentage: {
          BOOKED: 'Occupancy percentage',
          CANCELLED: 'Cancellation percentage'
        }
      },
      wizard: {
        reservation: 'Make reservation',
        dataUser: 'Your Data',
        finalize: 'Finish',
        confirmation: 'Confirmation?'
      }
    }
  }
} as Record<string, LocaleMessageDictionary<VueMessageType>>;
